import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/_components/alert-dialog";
import {
  getGetAllSupplementDataQueryKey,
  useDeleteSupplementData,
} from "@/lib/api/engageApi";
import { useQueryClient } from "@tanstack/react-query";
import { TrashIcon } from "lucide-react";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { Button } from "@/components/_components/button";

const DeleteSupplementData = ({ id }: { id: number }) => {
  const queryClient = useQueryClient();
  const { mutate, error, isSuccess } = useDeleteSupplementData();

  useEffect(() => {
    if (isSuccess) {
      queryClient.invalidateQueries({
        queryKey: getGetAllSupplementDataQueryKey(),
      });
      toast.success("Master Data deleted successfully!");
    }
    if (error) {
      toast.error("Error deleting Master Data: " + error.message);
    }
  }, [isSuccess, error, queryClient]);

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="destructive" size={"icon"}>
          <TrashIcon />
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone. This will permanently remove the data
            from our servers.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              mutate({ id });
            }}
          >
            Continue
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteSupplementData;